// extracted by mini-css-extract-plugin
export default {"sectionDivider":"sectionDivider---FGKeM","viewAsSection":"viewAsSection---QJQMD"};